import { PROJECTION_OBSERVER_POLICY } from '../policies/projectionObserver.policy.js';

export function requestProjectionReceipt(socket, event, payload, reply) {
  if (!socket?.connected || typeof socket.timeout !== 'function') { reply(null); return; }
  try {
    socket.timeout(PROJECTION_OBSERVER_POLICY.transportTimeoutMs).emit(event, payload,
      (error, result) => reply(error ? null : result));
  } catch { reply(null); }
}
